import dashboardApi from 'services/api/dashboard'
import LocalUserService from 'services/localUserService'
import store from 'main/store'
import { getSavedSubsidiary } from 'utils/helpers'

const userService = new LocalUserService()

function resolveSubsidiaryId(currentUserInfo) {
  const savedSubsidiary = getSavedSubsidiary()
  return (
    currentUserInfo?.subsidiaryId ||
    store.getState().login.currentHotelId ||
    (savedSubsidiary && savedSubsidiary.subsidiaryId) ||
    null
  )
}

export async function tryRenewStoredSession(options = {}) {
  const { requireUser = true } = options
  const currentUserInfo = userService.getCurrentUserInfo()

  if (!currentUserInfo?.sessionId || !currentUserInfo?.userToken) {
    return null
  }

  if (requireUser && !currentUserInfo?.user) {
    return null
  }

  const subsidiaryId = resolveSubsidiaryId(currentUserInfo)
  if (!subsidiaryId) {
    return null
  }

  const lastGeoLocation = store.getState().signIn?.geoLocation || {
    latitude: 0,
    longitude: 0
  }

  try {
    const sessionRenewResponse = await dashboardApi.renewSession({
      sessionId: currentUserInfo.sessionId,
      userToken: currentUserInfo.userToken,
      geoLocation: lastGeoLocation,
      screen: `${window.screen.width}x${window.screen.height}`,
      subsidiaryId
    })

    const renewResult = sessionRenewResponse?.result ?? sessionRenewResponse
    if (!renewResult?.sessionId) {
      return null
    }

    userService.updateSessionInfo(renewResult.sessionId, renewResult.userToken, {
      userId: renewResult.userId,
      dashboardUserId: renewResult.dashboardUserId,
      subsidiaryId
    })

    return {
      user: currentUserInfo.user,
      userToken: renewResult.userToken,
      userId: renewResult.userId,
      sessionId: renewResult.sessionId
    }
  } catch (error) {
    console.warn('tryRenewStoredSession failed', error)
    return null
  }
}
